import moment from 'moment';
import { getMomentFromCurruntTime } from '../../utils';
import {
  combineTradeData,
  combineUnderlyingData,
  convertDataToTradingData,
  convertUnderlyingCsvToTradingData,
  convertUnderlyingDataToTradingData,
  getEntryTimeEdges,
  getLastValues,
  sumLiveTrade,
} from './generators';

export function updateSelect(fullData, targetid, selected) {
  if (!fullData.length) {
    return fullData;
  }

  for (let index = 0; index < fullData.length; index++) {
    const element = fullData[index];

    if (element.id === targetid) {
      element.selected = selected;
    } else {
      element.selected = false;
    }
  }

  return fullData;
}

export function updateChartData(action) {
  const responseData = convertDataToTradingData(action?.data?.data?.data || []);

  const { firstEntryTime, lastEntryTime } = getEntryTimeEdges(responseData);

  return {
    responseData,
    firstEntryTime,
    lastEntryTime,
  };
}

export function updateNextChartData(action, state) {
  const oldData = state.data || [];
  const responseData = convertDataToTradingData(action?.data?.data?.data || []);

  const newData = combineTradeData(oldData, responseData);

  const { firstEntryTime, lastEntryTime } = getEntryTimeEdges(newData);

  return {
    responseData: newData,
    firstEntryTime,
    lastEntryTime,
  };
}

export function updateChartLiveData(action, state) {
  const {
    data: feed = '',
    broker: brokerList,
    algo: algoList,
    fetchOptions,
  } = action || {};

  const [, toDate] = fetchOptions.date.split('_');

  const today = getMomentFromCurruntTime().format('YYYY-MM-DD');

  // avoid if not today
  if (today !== toDate) {
    return {
      liveUpdateAt: state.liveUpdateAt,
      pnlFeed: state.pnlFeed,
    };
  }

  if (!feed) {
    return {
      liveUpdateAt: state.liveUpdateAt,
      pnlFeed: state.pnlFeed,
    };
  }

  const [broker, algoId] = feed.split(',');
  const graphLevel = state.graphLevel;

  if (!graphLevel) {
    return {
      liveUpdateAt: state.liveUpdateAt,
      pnlFeed: state.pnlFeed,
    };
  }

  if (graphLevel === 'broker' && !brokerList.includes(broker)) {
    return {
      liveUpdateAt: state.liveUpdateAt,
      pnlFeed: state.pnlFeed,
    };
  }

  if (graphLevel === 'algo' && !algoList.includes(algoId)) {
    return {
      pnlFeed: state.pnlFeed,
      liveUpdateAt: state.liveUpdateAt,
    };
  }

  const pnlFeed = state.pnlFeed || [];

  pnlFeed.push(feed);

  return {
    pnlFeed,
    liveUpdateAt: Date.now(),
  };
}

export function updateMtmTotal(state) {
  const pnlFeed = state.pnlFeed || [];
  const oldData = state.data || [];

  // skip calculations if no pnlFeed
  if (!pnlFeed.length) {
    return {
      metaData: state.metaData,
      firstEntryTime: state.firstEntryTime,
      lastEntryTime: state.lastEntryTime,
      responseData: state.data,
    };
  }

  const lastValues = getLastValues(state.metaData?.lastValues || {}, pnlFeed);
  const sumData = sumLiveTrade(lastValues);
  const newData = combineTradeData(oldData, sumData);

  const sumFeed = sumData[0];
  const min = sumFeed.low;
  const max = sumFeed.high;
  const timeMoment = moment.utc(sumFeed.time * 1000).utcOffset('+00:00');
  const mtmTime = timeMoment.valueOf();

  console.log('lastValuesOld', state.metaData?.lastValues);
  console.log('lastValuesUpdated', lastValues);

  // match
  const metaData = state.metaData;

  if (metaData) {
    if (metaData.totalMTM || metaData.totalMTM === 0) {
      metaData.totalMTM = sumFeed.close;
      metaData.totalMTMAt = mtmTime;
    }

    if (metaData.minMTM || metaData.minMTM === 0) {
      if (min < metaData.minMTM) {
        metaData.minMTM = min;
        metaData.minMTMAt = mtmTime;
      }
    }

    if (metaData.maxMTM || metaData.maxMTM === 0) {
      if (max > metaData.maxMTM) {
        metaData.maxMTM = max;
        metaData.maxMTMAt = mtmTime;
      }
    }
  }

  // update last values in metadata
  metaData.lastValues = lastValues;

  const { firstEntryTime, lastEntryTime } = getEntryTimeEdges(newData);

  return {
    metaData,
    responseData: newData,
    firstEntryTime,
    lastEntryTime,
  };
}

//

export function updateChartUnderlyingData(action) {
  const responseData = convertUnderlyingDataToTradingData(
    action?.data?.data?.data || []
  );

  return responseData;
}

export function updateChartCombineUnderlyingData(data, state, underlyingName) {
  const oldData = state.data;

  if (!underlyingName || !state.underlying) {
    return oldData;
  }

  if (underlyingName !== state.underlying) {
    return oldData;
  }

  const responseData = convertUnderlyingDataToTradingData(data || []);
  const combinedData = combineUnderlyingData(oldData, responseData);

  return combinedData;
}

export function updateChartLiveUnderlyingData(action, state) {
  const { data: feed = '' } = action || {};
  const oldData = state.data;

  if (!feed) {
    return oldData;
  }

  const [underlying] = feed.split(',');

  if (!underlying) {
    return oldData;
  }

  if (state.underlying !== underlying) {
    return oldData;
  }

  const responseData = convertUnderlyingCsvToTradingData(feed) || [];

  const combinedData = combineUnderlyingData(oldData, responseData);

  return combinedData;
}
